/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { SortTypeEnum } from '../models/SortTypeEnum';
import type { WarrantyClaimNoteStatusEnum } from '../models/WarrantyClaimNoteStatusEnum';
import type { WarrantyLogDto } from '../models/WarrantyLogDto';
import type { WarrantyLogDtoPagedListData } from '../models/WarrantyLogDtoPagedListData';
import type { WarrantyLogEditInput } from '../models/WarrantyLogEditInput';
import type { WarrantyLogFileDto } from '../models/WarrantyLogFileDto';
import type { WarrantyLogInput } from '../models/WarrantyLogInput';
import type { WarrantyLogNoteInput } from '../models/WarrantyLogNoteInput';
import type { WarrantyTypeDto } from '../models/WarrantyTypeDto';
import type { WarrantyWipInfo } from '../models/WarrantyWipInfo';
import type { WaUserDto } from '../models/WaUserDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WarrantyLogService {

  /**
   * @param fromDate 
   * @param toDate 
   * @param wipNo 
   * @param regNo 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param manufacturerId 
   * @param warrantyTypeIds 
   * @param waStatuses 
   * @param warrantyLogStatuses 
   * @param adminIds 
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns WarrantyLogDtoPagedListData Success
   * @throws ApiError
   */
  public static getWarrantyLog(
fromDate?: string,
toDate?: string,
wipNo?: number,
regNo?: string,
branch?: BranchType,
manufacturerId?: number,
warrantyTypeIds?: Array<number>,
waStatuses?: Array<number>,
warrantyLogStatuses?: Array<WarrantyClaimNoteStatusEnum>,
adminIds?: Array<number>,
sort?: string,
order?: SortTypeEnum,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<WarrantyLogDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WarrantyLog',
      query: {
        'FromDate': fromDate,
        'ToDate': toDate,
        'WipNo': wipNo,
        'RegNo': regNo,
        'Branch': branch,
        'ManufacturerId': manufacturerId,
        'WarrantyTypeIds': warrantyTypeIds,
        'WaStatuses': waStatuses,
        'WarrantyLogStatuses': warrantyLogStatuses,
        'AdminIds': adminIds,
        'Sort': sort,
        'Order': order,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postWarrantyLog(
requestBody?: WarrantyLogInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/WarrantyLog',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns WarrantyLogDto Success
   * @throws ApiError
   */
  public static getWarrantyLog1(
id: number,
): CancelablePromise<WarrantyLogDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WarrantyLog/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putWarrantyLog(
id: number,
requestBody?: WarrantyLogEditInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/WarrantyLog/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param logId 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postWarrantyLogNote(
logId: number,
requestBody?: WarrantyLogNoteInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/WarrantyLog/note/{logId}',
      path: {
        'logId': logId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns WarrantyTypeDto Success
   * @throws ApiError
   */
  public static getWarrantyLogWarrantyTypes(): CancelablePromise<Array<WarrantyTypeDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WarrantyLog/WarrantyTypes',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns WaUserDto Success
   * @throws ApiError
   */
  public static getWarrantyLogWaUsers(): CancelablePromise<Array<WaUserDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WarrantyLog/WaUsers',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param wipNo 
   * @param branchId 
   * @returns WarrantyWipInfo Success
   * @throws ApiError
   */
  public static getWarrantyLogWipInfo(
wipNo: number,
branchId: number,
): CancelablePromise<WarrantyWipInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WarrantyLog/WipInfo/{wipNo}/{branchId}',
      path: {
        'wipNo': wipNo,
        'branchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param logId 
   * @param formData 
   * @returns WarrantyLogFileDto Success
   * @throws ApiError
   */
  public static postWarrantyLogUploadFile(
logId: number,
formData?: {
File: Blob;
},
): CancelablePromise<WarrantyLogFileDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/WarrantyLog/{logId}/UploadFile',
      path: {
        'logId': logId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param logId 
   * @param fileUid 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteWarrantyLogDeleteFile(
logId: number,
fileUid: string,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/WarrantyLog/{logId}/DeleteFile/{fileUid}',
      path: {
        'logId': logId,
        'fileUid': fileUid,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
